export default __webpack_public_path__ + "static/media/upload-check.a0a71136.svg";